const moveIcon = "_35smkdsrvj";

export { moveIcon };
import "./atom.move-icon.style.linaria.module.css";
//# sourceMappingURL=atom.move-icon.style.js.map
